var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFrontDesk = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Reception Hotel Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 7v1a5 5 0 0 0 10 0V7M17 7H7V2.7a.98.98 0 0 1 .66-.94 12.7 12.7 0 0 1 8.68 0 .98.98 0 0 1 .66.94ZM22 27H3a2 2 0 0 0-2 2v18M42 27h3a2 2 0 0 1 2 2v18"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 32a2 2 0 0 0-2 2v2h-4v-2a2 2 0 0 0-4 0v9a2 2 0 0 0 4 0v-3h4v3a2 2 0 0 0 4 0v-9a2 2 0 0 0-2-2M29 6a5 5 0 1 0 10 0 5 5 0 1 0-10 0M37 45l1-14h2a2 2 0 0 0 2-2v-6a8 8 0 0 0-16 0v6a2 2 0 0 0 2 2h2l1 14a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M4.26 23a8 8 0 0 1 15.48 0"
}))));
export { SvgFrontDesk as ReactComponent };
export default __webpack_public_path__ + "assets/images/frontDesk.svg";